<template>

    <form ref="contacorrentecarteira-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="contaCorrenteId">ContaCorrenteId</label>
                        <input type="text" class="form-control" name="contaCorrenteId" placeholder="ContaCorrenteId" v-model="model.contaCorrenteId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="carteiraId">CarteiraId</label>
                        <input type="text" class="form-control" name="carteiraId" placeholder="CarteiraId" v-model="model.carteiraId" required />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="cNAB" class="custom-control-input" v-model="model.cNAB">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> CNAB?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="ativa" class="custom-control-input" v-model="model.ativa">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Ativa?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <label for="taxaBoleto">TaxaBoleto</label>
                        <input type="text" class="form-control" name="taxaBoleto" placeholder="TaxaBoleto" v-model="model.taxaBoleto" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="codigoCedente">CodigoCedente</label>
                        <input type="text" class="form-control" name="codigoCedente" placeholder="CodigoCedente" v-model="model.codigoCedente" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="nossoNumeroInicial">NossoNumeroInicial</label>
                        <input type="text" class="form-control" name="nossoNumeroInicial" placeholder="NossoNumeroInicial" v-model="model.nossoNumeroInicial" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="numeroRemessaInicial">NumeroRemessaInicial</label>
                        <input type="text" class="form-control" name="numeroRemessaInicial" placeholder="NumeroRemessaInicial" v-model="model.numeroRemessaInicial" required />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="principal" class="custom-control-input" v-model="model.principal">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Principal?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="bancoEmite" class="custom-control-input" v-model="model.bancoEmite">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> BancoEmite?</span>
                        </label>
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "contacorrentecarteira-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "contacorrentecarteira-form-create",
            
            resources: {
                create: 'contacorrentecarteira',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

